import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import SocialButtons from './SocialButtons';
export default class InfoBlock extends Component {
  view() {
    var _app$forum$attribute;
    const titleContent = (_app$forum$attribute = app.forum.attribute('modern-footer.title-1')) == null ? void 0 : _app$forum$attribute.trim();
    const rightText = app.forum.attribute('modern-footer.right-text');
    return m("div", {
      class: "foo-left"
    }, m("div", null, titleContent ? titleContent.startsWith('http') ? m("h3", null, m("img", {
      src: titleContent,
      alt: "Footer Logo"
    })) : m("h3", null, m.trust(titleContent)) : null, rightText && m("p", null, rightText), m(SocialButtons, null)));
  }
}
flarum.reg.add('huseyinfiliz-modern-footer', 'forum/components/InfoBlock', InfoBlock);